import React from 'react';
import { RinkSection } from '../../components';
import { homeObjTwo } from './Data';

const Projects = () => {
  return (
    <>
      <RinkSection {...homeObjTwo} />

    </>
  );
}

export default Projects;
